import axios from "axios";
import { saveAs } from "file-saver";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { dataURLToImage, imageToCanvas } from "../../../utils/imageUtils";
import ImageEditor from "../ImageEditor";

const ImageEditorPage = ({ getBilde, postIleggelserBilder }) => {
  const navigate = useNavigate();
  const { id: ileggelseId } = useParams();
  const [bilde, setBilde] = useState(undefined);
  const [isGetBildeCalled, setIsGetBildeCalled] = useState(false);
  const [imageEditorRef, setImageEditorRef] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const source = axios.CancelToken.source();

    if (!isGetBildeCalled) {
      setIsGetBildeCalled(true);
      getBilde().then((result) => {
        setBilde(result);
      });
    }

    return () => {
      source.cancel("componentWillUnmount triggered");
    };
  }, [isGetBildeCalled, getBilde]);

  const handleTilbakeButtonClick = () => {
    navigate(-1);
  };

  const handleLastNedButtonClick = () => {
    if (!imageEditorRef) return;

    var supportingFileAPI = !!(
      window.File &&
      window.FileList &&
      window.FileReader
    );
    var imageName = imageEditorRef.getImageName();
    var dataURLPng = imageEditorRef.toDataURL();

    if (supportingFileAPI) {
      dataURLToImage(dataURLPng, (image) => {
        const canvas = imageToCanvas(image);
        canvas.toBlob(async (blob) => {
          let type = blob.type.split("/")[1];
          if (imageName.split(".").pop() !== type) {
            imageName += "." + type;
          }
          // Library: FileSaver - saveAs
          saveAs(blob, imageName); // eslint-disable-line
        }, "image/jpeg");
      });
    } else {
      alert("This browser needs a file-server");
      let w = window.open();
      w.document.body.innerHTML = "<img src=" + dataURLPng + ">";
    }
  };

  const handleLastOppButtonClick = async () => {
    if (!imageEditorRef) return;

    const dataURLPng = imageEditorRef.toDataURL();
    dataURLToImage(dataURLPng, (image) => {
      const canvas = imageToCanvas(image);
      canvas.toBlob(async (blob) => {
        await postIleggelserBilder(ileggelseId, blob);
        alert("Bildet er lastet opp!");
      }, "image/jpeg");
    });
  };

  return (
    <React.Fragment>
      {bilde && (
        <div>
          {/* Custom toolbar */}
          <div
            style={{
              padding: "10px 20px",
              backgroundColor: "#f8f9fa",
              borderBottom: "1px solid #dee2e6",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <button
              onClick={handleTilbakeButtonClick}
              style={{
                backgroundColor: "#6c757d",
                border: "1px solid #6c757d",
                color: "#fff",
                fontFamily: "'Noto Sans', sans-serif",
                fontSize: "12px",
                padding: "8px 16px",
                cursor: "pointer",
                borderRadius: "4px",
              }}
            >
              Tilbake
            </button>

            <div>
              <button
                onClick={handleLastNedButtonClick}
                style={{
                  backgroundColor: "#fdba3b",
                  border: "1px solid #fdba3b",
                  color: "#fff",
                  fontFamily: "'Noto Sans', sans-serif",
                  fontSize: "12px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  marginRight: "10px",
                }}
              >
                Last ned
              </button>

              <button
                onClick={handleLastOppButtonClick}
                style={{
                  backgroundColor: "#28a745",
                  border: "1px solid #28a745",
                  color: "#fff",
                  fontFamily: "'Noto Sans', sans-serif",
                  fontSize: "12px",
                  padding: "8px 16px",
                  cursor: "pointer",
                  borderRadius: "4px",
                }}
              >
                Last opp
              </button>
            </div>
          </div>

          <ImageEditor setImageEditorRef={setImageEditorRef} imageSrc={bilde} />
        </div>
      )}
      {!bilde && <div style={{ padding: "20px" }}>Laster bilde...</div>}
    </React.Fragment>
  );
};

export default ImageEditorPage;
